import React from 'react'
import Agenda from '../../components/Agenda'
import { useSelector } from 'react-redux'

export default function CalendarTab(props){
  const { resident, organization, current_user, config } = useSelector(state=>state)
  return(
    <Agenda
      resident={resident}
      current_user={ current_user }
      config={{ showSidePanel: false, height: "", sender_url: resident.sender_url + '#calendar', isStaffApp: config.isStaffApp, sender_name: resident.name }}
      organization={ organization }
      selected={{id: resident.id, name: resident.name, resource_type: 'Resident'}}
    />
  )
}